import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0f7d9a62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div style=\"border-bottom:2px solid #fb7626;\" class=\"container-fluid p-0 m-0\" data-v-0f7d9a62><div style=\"background:linear-gradient(15deg,#05292d 50%, #0f535a 100%);\" class=\"p-0 m-0 row\" data-v-0f7d9a62><div class=\"col text-center\" data-v-0f7d9a62><span class=\"text-center datosdecontacto\" data-v-0f7d9a62>Management &amp; administration</span><span class=\"text-center datosdecontactoblanco\" data-v-0f7d9a62> ✆ (+504) 9551-2398</span><span class=\"text-center datosdecontacto\" data-v-0f7d9a62> Sales</span><span class=\"text-center datosdecontactoblanco\" data-v-0f7d9a62> ✆ (+504) 2544-0134</span><span class=\"text-center datosdecontacto\" data-v-0f7d9a62> Operations </span><span class=\"text-center datosdecontactoblanco\" data-v-0f7d9a62> ✆ (+504) 3312-2189 (+504) 3291-1607 </span><span class=\"text-center datosdecontacto\" data-v-0f7d9a62> ✉<a style=\"background:transparent;\" href=\"mailto:info@latamlogistichn.com\" data-v-0f7d9a62>info@latamlogistichn.com</a></span></div></div></div>", 1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "San Pedro Sula, Cortés, Honduras.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-center mt-5" }, "LATAM LOGISTIC SERVICE")
  ])
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "col",
  style: {"z-index":"200 !important"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Principal")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Quienes Somos")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Contacto")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "primero",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "medio",
            to: "quienessomos"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "final",
            to: "contacto"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}